module.exports = __webpack_public_path__ + "img/provider2.5c311ceb.svg";